import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FaAngleDown, FaSyncAlt } from "react-icons/fa";
import FlightDetailSide from "./FlightDetailSide";

import { useNavigate } from "react-router-dom";

import PromoCode from "./PromoCode";
const currencySymbol = {
  USD: "$",
  INR: "₹",
  EUR: "€",
  GBP: "£",
};
const ChargesOneWay = ({
  srdvIdx,
  flight,
  flight2,
  setShowdetail,
  loadingFareRecheck,
  priceChanged,
  showdetail,
  handleChangeCurrency,
  handleChangeCurrency2,
  walletData,
  setOpenPayBtn,
  openPayBtn,
  setPaymentGateway,
  paymentGateway,
  setEmiBtn,
  emiBtn,
  passengerSeatPreferences,
  passengerMealPreferences,
  passengerBaggagePreferences,
  validatePassengerData,
  totalSeatPrice,
  reviewPageDone,
  totalBaggagePrice,
  totalMealPrice,
  handlePayment,
}) => {
  let totalMealCharges = passengerMealPreferences.reduce((total, meal) => {
    if (meal && meal.Price) {
      total += meal.Price;
    }
    return total;
  }, 0);

  let totalMealWithCharges =
    (flight && srdvIdx != "undefined" && flight.Fare.TotalMealCharges) +
    totalMealCharges;

  let totalSeatCharges = passengerSeatPreferences.reduce((total, meal) => {
    if (meal && meal.Price) {
      total += meal.Price;
    }
    return total;
  }, 0);

  let totalSeatWithCharges =
    (flight && srdvIdx != "undefined" && flight.Fare.TotalSeatCharges) +
    totalSeatCharges;

  let totalBaggageCharges = passengerBaggagePreferences.reduce(
    (total, meal) => {
      if (meal && meal.Price) {
        total += meal.Price;
      }
      return total;
    },
    0
  );

  let totalBaggageWithCharges =
    (flight && srdvIdx != "undefined" && flight.Fare.TotalBaggageCharges) +
    totalBaggageCharges;

  const handleFareRecheck = () => {
    // console.log("fare recheck clicked");
  };

  const navigate = useNavigate();
  // console.log("flightchargesoneway", flight2);

  console.log("openpaybtn2", openPayBtn);
  console.log("paymentgateway2", paymentGateway);

  const [isSticky, setIsSticky] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 70);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <>
      {srdvIdx != "undefined" && (
        <Col
          md={3}
          // className={`flight_charges_mainCOntainer ${
          //   isSticky ? "position_Top" : "stick_positionTop"
          // }
          // `}
        >
          <Row className="fare_detail_desktop">
            <Col md={12}>
              {flight ? (
                <>
                  {flight2 ? (
                    <div className="flightBookingsecDiv">
                      <Row className="flightBookingSecDivRow3">
                        <Col xs={12} md={12}>
                          <span
                            className="lbl"
                            // onClick={() => setShowdetail(!showdetail)}
                          >
                            Fare Summary
                            {/* (
                        {flight.FareBreakdown.reduce(
                          (total, item) => total + item.PassengerCount,
                          0
                        )}{" "}
                        Travellers) */}
                          </span>{" "}
                          {/* <FaAngleDown onClick={() => setShowdetail(!showdetail)} />{" "} */}
                          <span className="val">
                            {/* {flight.Fare.Currency}  */}
                            {flight.FareBreakdown.reduce(
                              (total, item) => total + item.PassengerCount,
                              0
                            )}{" "}
                            Travellers
                          </span>
                        </Col>
                      </Row>
                      {showdetail && (
                        <Row
                          className="flightBookingSecDivRow3"
                          style={{ width: "90%", marginInline: "auto" }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">
                              {flight.FareBreakdown[0].PassengerCount} x Adult
                            </span>{" "}
                            <span className="val">
                              {/* {flight.FareBreakdown[0].Currency} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(
                                flight.FareBreakdown[0].BaseFare +
                                  flight2.FareBreakdown[0].BaseFare
                              )}
                            </span>
                          </Col>
                          {flight.FareBreakdown[1] && (
                            <Col xs={12} md={12}>
                              <span className="lbl">
                                {flight.FareBreakdown[1].PassengerCount} x
                                Children
                              </span>{" "}
                              <span className="val">
                                {currencySymbol[flight.Currency] || ""}
                                {Math.round(
                                  flight.FareBreakdown[1].BaseFare +
                                    flight2.FareBreakdown[1].BaseFare
                                )}
                              </span>
                            </Col>
                          )}
                          {flight.FareBreakdown[2] && (
                            <Col xs={12} md={12}>
                              <span className="lbl">
                                {flight.FareBreakdown[2].PassengerCount} x
                                Infants
                              </span>{" "}
                              <span className="val">
                                {/* {flight.FareBreakdown[2].Currency} */}{currencySymbol[flight.Currency] || ""}
                                {Math.round(
                                  flight.FareBreakdown[2].BaseFare +
                                    flight2.FareBreakdown[1].BaseFare
                                )}
                              </span>
                            </Col>
                          )}
                        </Row>
                      )}
                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Base Fare</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                            {Math.round(
                              flight.Fare.BaseFare + flight2.Fare.BaseFare
                            )}
                          </span>
                        </Col>
                      </Row>

                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Taxes & Surcharges</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                            {Math.round(flight.Fare.Tax  + flight2.Fare.Tax)}
                          </span>
                        </Col>
                      </Row>

                      {totalMealPrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Meals</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalMealPrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      {totalBaggagePrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Baggage</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalBaggagePrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      {totalSeatPrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Seats</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalSeatPrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Discount</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                            0
                          </span>
                        </Col>
                      </Row>

                      <Row
                        className="flightBookingsecDivRow"
                        style={{ marginTop: "0px" }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">You Pay:</span> -{" "}
                          <span className="val">
                            {currencySymbol[flight.Currency] || ""}
                            {Math.round(
                              flight.Fare.PublishedFare +
                                flight2.Fare.PublishedFare +
                                totalSeatPrice +
                                totalMealPrice +
                                totalBaggagePrice
                            )}
                          </span>
                        </Col>
                      </Row>
                      {reviewPageDone ? (
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-15px" }}
                          onClick={handlePayment}
                        >
                          {" "}
                           {loadingFareRecheck ? (
                              <div className="three-dot-loader"></div>
                            ) : (
                              <>
                                {!reviewPageDone ? (
                                  <button className="ewalletbtn">
                                    Continue Booking
                                  </button>
                                ) : (
                                  <button className="ewalletbtn">
                                    Confirm Booking
                                  </button>
                                )}
                              </>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-15px" }}
                          onClick={async () => {
                            if (validatePassengerData()) {
                              setOpenPayBtn(true);
                              setPaymentGateway(true);
                            }
                          }}
                        >
                          {" "}
						  {loadingFareRecheck ? (
                              <div className="three-dot-loader"></div>
                            ) : (
                          <button className="ewalletbtn">
                            Continue Booking
                          </button>
						   )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="flightBookingsecDiv">
                      <Row className="flightBookingSecDivRow3">
                        <Col xs={12} md={12}>
                          <span
                            className="lbl"
                            // onClick={() => setShowdetail(!showdetail)}
                          >
                            Fare Summary
                            {/* (
                        {flight.FareBreakdown.reduce(
                          (total, item) => total + item.PassengerCount,
                          0
                        )}{" "}
                        Travellers) */}
                          </span>{" "}
                          {/* <FaAngleDown onClick={() => setShowdetail(!showdetail)} />{" "} */}
                          <span className="val">
                            {/* {flight.Fare.Currency}  */}
                            {flight.FareBreakdown.reduce(
                              (total, item) => total + item.PassengerCount,
                              0
                            )}{" "}
                            Travellers
                          </span>
                        </Col>
                      </Row>
                      {showdetail && (
                        <Row
                          className="flightBookingSecDivRow3"
                          style={{ width: "90%", marginInline: "auto" }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">
                              {flight.FareBreakdown[0].PassengerCount} x Adult
                            </span>{" "}
                            <span className="val">
                              {/* {flight.FareBreakdown[0].Currency} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(flight.FareBreakdown[0].BaseFare)}
                            </span>
                          </Col>
                          {flight.FareBreakdown[1] && (
                            <Col xs={12} md={12}>
                              <span className="lbl">
                                {flight.FareBreakdown[1].PassengerCount} x
                                Children
                              </span>{" "}
                              <span className="val">
                                {/* {flight.FareBreakdown[1].Currency} */}{currencySymbol[flight.Currency] || ""}
                                {Math.round(flight.FareBreakdown[1].BaseFare)}
                              </span>
                            </Col>
                          )}
                          {flight.FareBreakdown[2] && (
                            <Col xs={12} md={12}>
                              <span className="lbl">
                                {flight.FareBreakdown[2].PassengerCount} x
                                Infants
                              </span>{" "}
                              <span className="val">
                                {/* {flight.FareBreakdown[2].Currency} */}{currencySymbol[flight.Currency] || ""}
                                {Math.round(flight.FareBreakdown[2].BaseFare)}
                              </span>
                            </Col>
                          )}
                        </Row>
                      )}
                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Base Fare</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                            {Math.round(flight.Fare.BaseFare)}
                          </span>
                        </Col>
                      </Row>
                      {totalMealPrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Meals</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalMealPrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      {totalBaggagePrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Baggage</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalBaggagePrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      {totalSeatPrice !== 0 && (
                        <Row
                          className="flightBookingSecDivRow2"
                          style={{
                            paddingBlock: "8px",
                            borderBottom: "1px solid #e4e4e4",
                          }}
                        >
                          <Col xs={12} md={12}>
                            <span className="lbl">Seats</span> -{" "}
                            <span className="val">
                              {/* {flight.Fare.Currency}{" "} */}{currencySymbol[flight.Currency] || ""}
                              {Math.round(totalSeatPrice)}
                            </span>
                          </Col>
                        </Row>
                      )}
                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Taxes & Surcharges</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                            {Math.round(flight.Fare.Tax)}
                          </span>
                        </Col>
                      </Row>

                      <Row
                        style={{
                          borderBottom: "1px solid #e4e4e4",
                          paddingBlock: "8px",
                        }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">Discount</span> -{" "}
                          <span className="val">
                            {/* {flight.Fare.Currency} */}{currencySymbol[flight.Currency] || ""}
                           0
                          </span>
                        </Col>
                      </Row>

                      <Row
                        className="flightBookingsecDivRow"
                        style={{ marginTop: "0px" }}
                      >
                        <Col xs={12} md={12}>
                          <span className="lbl">You Pay:</span> -{" "}
                          <span className="val">
                            {currencySymbol[flight.Currency] || ""}
                            {Math.round(
                              flight.Fare.PublishedFare +
                                totalSeatPrice +
                                totalMealPrice +
                                totalBaggagePrice
                            )}
                          </span>
                        </Col>
                      </Row>
                      {reviewPageDone ? (
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-15px" }}
                          onClick={handlePayment}
                        >
                          {" "}
                           {loadingFareRecheck ? (
                              <div className="three-dot-loader"></div>
                            ) : (
                              <>
                                {!reviewPageDone ? (
                                  <button className="ewalletbtn">
                                    Continue Booking
                                  </button>
                                ) : (
                                  <button className="ewalletbtn">
                                    Confirm Booking
                                  </button>
                                )}
                              </>
                            )}
                        </div>
                      ) : (
                        <div
                          style={{ marginLeft: "-15px", marginRight: "-15px" }}
                          onClick={async () => {
                            if (validatePassengerData()) {
                              setOpenPayBtn(true);
                              setPaymentGateway(true);
                            }
                          }}
                        >
                          {" "}
                          {loadingFareRecheck ? (
                              <div className="three-dot-loader"></div>
                            ) : (
                              <>
                                {!reviewPageDone ? (
                                  <button className="ewalletbtn">
                                    Continue Booking
                                  </button>
                                ) : (
                                  <button className="ewalletbtn">
                                    Confirm Booking
                                  </button>
                                )}
                              </>
                            )}
                        </div>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <FlightDetailSide />
              )}
            </Col>
          </Row>
          { /*<PromoCode /> */ }
        </Col>
      )}
      
    </>
  );
};

export default ChargesOneWay;
